import { DataBean } from "../DataBean";

export class IncidentReport extends DataBean {

    public async createIncidentReport(idEmployee: number, message: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.IncidentReport_createIncidentReport_Number_String", [idEmployee, message]);
    }

    public async getIncidentReportByIncidentCode(idEmployee: number, incidentCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.IncidentReport_getIncidentReportByIncidentCode_Number_String", [idEmployee, incidentCode]);
    }

    public async getIncidentReport(page: number, rows: number, props: any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_getIncidentReport_Number_Number_java.util.Map", [page, rows, props]);
    }

    public async addAttachtoIssue(issueId: number, media: string, mediaContext: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_addAttachtoIssue_Number_String_String", [issueId, media, mediaContext]);
    }

    public async addNoteToIncident(issueId: number, note: string, media: string, mediaContext: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_addNoteToIncident_Number_String_String_String", [issueId, note, media, mediaContext]);
    }

    public async getIssuesFiles(issueID: number): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.IncidentReport_getIssuesFiles_Number", [issueID]);
    }

    public async getIssuesFilesById(issueID: number, idFile: number ): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.IncidentReport_getIssuesFilesById_Number_Number", [issueID, idFile]);
    }

    public async changeIncidentReportStatus(IncidentReport: number, State: number ): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.cache.bean.IncidentReport_changeIncidentReportStatus_Number_Number", [IncidentReport, State]);
    }
}